'use strict';

const urlJoin = require('url-join');
const { default: stipulate, buildOptions } = require('stipulate');

const { baseOptions } = require('./configuration');
const config = require('../config');

const generateAuthToken = (options = {}) => {
  const { baseUrl } = config.get();

  const url = urlJoin(baseUrl, '/pb/users/me/generate-site-ws-auth-token/');
  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(options),
  });

  return stipulate(url, requestOptions);
};

module.exports = generateAuthToken;
